/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManageUserProfile } from '../../models/manage-user-profile';
import { ManageUserProfileApiRespModel } from '../../models/manage-user-profile-api-resp-model';

export interface ApiUserAddUserPost$Params {
      body?: ManageUserProfile
}

export function apiUserAddUserPost(http: HttpClient, rootUrl: string, params?: ApiUserAddUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfileApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiUserAddUserPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManageUserProfileApiRespModel>;
    })
  );
}

apiUserAddUserPost.PATH = '/api/User/AddUser';
